import { createSlice } from '@reduxjs/toolkit';
import { AsyncState } from '../types';
import { SkillDto } from '../../http';
import { FindAllResponse } from '../../http/types';
import { createFetchAsync } from '../slice.utils';
import { SkillApi } from '../../http/requests/skill.api';

const skillApi = new SkillApi();

export const fetchSkillAsync = createFetchAsync(
  'skill',
  'findAll',
  async (params, { rejectWithValue }) => {
    try {
      return await skillApi.findAll({ limit: 1000, ...params });
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const forceFetchSkill = fetchSkillAsync.asyncThunk;

export const fetchSkill = (payload) => (dispatch, getState) => {
  const {
    skill: { findAll }
  } = getState();

  if (!findAll.payload && findAll.loading == false) {
    dispatch(forceFetchSkill(payload));
  }
};

type SkillState = {
  findAll: AsyncState<FindAllResponse<SkillDto>>;
};

const initialState: SkillState = {
  findAll: fetchSkillAsync.initialState
};

const skill = createSlice({
  name: 'skill',
  initialState,
  reducers: {},
  extraReducers: {
    ...fetchSkillAsync.extraReducers
  }
});

export default skill.reducer;
